import { WebApiService } from '../../plugins/webApiService'
import { Events } from '../../plugins/events'
import { SendRequestModel } from '../../plugins/models/SendRequestModel'
import AttachFileBaseRequest from '../../files/interfaces/models/request/AttachFileBaseRequest';
import AttachFotoRequest from '../../files/interfaces/models/AttachFotoRequest';
import FotoRequest from '../../files/interfaces/models/FotoRequest';
import GetInfoRequest from '../../files/interfaces/models/request/GetInfoRequest';
import CreateFolderRequest from '../../files/interfaces/models/CreateFolderRequest';
import FolderPermissionRequest from '../../files/interfaces/models/FolderPermissionRequest';
import AccessPermissionRequest from '../../files/interfaces/models/AccessPermissionRequest';
import MoveFilesRequest from '../../files/interfaces/models/MoveFilesRequest';
import MoveFolderRequest from '../../files/interfaces/models/MoveFolderRequest';
import RemoveFileRequest from '../../files/interfaces/models/RemoveFileRequest';
import RemoveFolderRequest from '../../files/interfaces/models/RemoveFolderRequest';
import CombinePathFolderRequest from '../../files/interfaces/models/request/CombinePathFolderRequest';
import WsResponseModelT from '../../schema-builder-server/models/WsResponseModelT';
import AttachFileResponse from '../../files/interfaces/models/response/AttachFileResponse';
import AttachFotoResponse from '../../files/interfaces/models/AttachFotoResponse';
import FilePageResponse from '../../files/interfaces/models/response/FilePageResponse';
import AccessPermissionResponse from '../../files/interfaces/models/AccessPermissionResponse';

export default class FileS3Service {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	AttachFileEvent = new Events<WsResponseModelT<AttachFileResponse>>();
	AttachFotoEvent = new Events<WsResponseModelT<AttachFotoResponse>>();
	AttachFotoNotFolderEvent = new Events<WsResponseModelT<String>>();
	RemoveFotoNotFolderEvent = new Events<WsResponseModelT<Boolean>>();
	AttachFotoNoCorpEvent = new Events<WsResponseModelT<AttachFotoResponse>>();
	FolderInfoEvent = new Events<WsResponseModelT<FilePageResponse>>();
	CreateFolderEvent = new Events<WsResponseModelT<String>>();
	GetAccessPermissionEvent = new Events<WsResponseModelT<Array<AccessPermissionResponse>>>();
	IsAccessPermissionEvent = new Events<WsResponseModelT<Boolean>>();
	MoveFileEvent = new Events<WsResponseModelT<Boolean>>();
	MoveFolderEvent = new Events<WsResponseModelT<Boolean>>();
	RemoveFileEvent = new Events<WsResponseModelT<Boolean>>();
	RemoveFolderEvent = new Events<WsResponseModelT<Boolean>>();
	SetAccessPermissionEvent = new Events<WsResponseModelT<Boolean>>();
	CombinePathFolderEvent = new Events<WsResponseModelT<String>>();
	DetectCopyFilesEvent = new Events<WsResponseModelT<String>>();
	IsImageExtensionEvent = new Events<WsResponseModelT<Boolean>>();
	GetPathEvent = new Events<WsResponseModelT<String>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('FileS3Service', 'AttachFile', 'Main', (res: WsResponseModelT<AttachFileResponse>) => {
			self.AttachFileEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'AttachFoto', 'Main', (res: WsResponseModelT<AttachFotoResponse>) => {
			self.AttachFotoEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'AttachFotoNotFolder', 'Main', (res: WsResponseModelT<String>) => {
			self.AttachFotoNotFolderEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'RemoveFotoNotFolder', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveFotoNotFolderEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'AttachFotoNoCorp', 'Main', (res: WsResponseModelT<AttachFotoResponse>) => {
			self.AttachFotoNoCorpEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'FolderInfo', 'Main', (res: WsResponseModelT<FilePageResponse>) => {
			self.FolderInfoEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'CreateFolder', 'Main', (res: WsResponseModelT<String>) => {
			self.CreateFolderEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'GetAccessPermission', 'Main', (res: WsResponseModelT<Array<AccessPermissionResponse>>) => {
			self.GetAccessPermissionEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'IsAccessPermission', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.IsAccessPermissionEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'MoveFile', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.MoveFileEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'MoveFolder', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.MoveFolderEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'RemoveFile', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveFileEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'RemoveFolder', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveFolderEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'SetAccessPermission', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.SetAccessPermissionEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'CombinePathFolder', 'Main', (res: WsResponseModelT<String>) => {
			self.CombinePathFolderEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'DetectCopyFiles', 'Main', (res: WsResponseModelT<String>) => {
			self.DetectCopyFilesEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'IsImageExtension', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.IsImageExtensionEvent.trigger(res);
		});
		webApiService.on('FileS3Service', 'GetPath', 'Main', (res: WsResponseModelT<String>) => {
			self.GetPathEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Вставка файла
	 */
	async AttachFile(request: AttachFileBaseRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'AttachFile',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Отправить фото
	 */
	async AttachFoto(request: AttachFotoRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'AttachFoto',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Вставка без папки
	 */
	async AttachFotoNotFolder(request: FotoRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'AttachFotoNotFolder',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async RemoveFotoNotFolder(UrlFoto: string) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'RemoveFotoNotFolder',
			Value: typeof(UrlFoto) === 'object' ? JSON.stringify(UrlFoto) : UrlFoto,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Вставка без обрезки
	 */
	async AttachFotoNoCorp(request: AttachFotoRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'AttachFotoNoCorp',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить информацыю о содержимом папки
	 */
	async FolderInfo(request: GetInfoRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'FolderInfo',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Создание папки
	 */
	async CreateFolder(model: CreateFolderRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'CreateFolder',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение прав доступа
	 */
	async GetAccessPermission(model: FolderPermissionRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'GetAccessPermission',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Проверка доступа
	 */
	async IsAccessPermission(model: AccessPermissionRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'IsAccessPermission',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	async MoveFile(model: MoveFilesRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'MoveFile',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	async MoveFolder(model: MoveFolderRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'MoveFolder',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление файла
	 */
	async RemoveFile(model: RemoveFileRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'RemoveFile',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удаление папки
	 */
	async RemoveFolder(model: RemoveFolderRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'RemoveFolder',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Установка прав
	 */
	async SetAccessPermission(model: AccessPermissionRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'SetAccessPermission',
			Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
		})

		webApiService.send(sendRequest);
	}

	async CombinePathFolder(request: CombinePathFolderRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'CombinePathFolder',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	async DetectCopyFiles(path: string) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'DetectCopyFiles',
			Value: typeof(path) === 'object' ? JSON.stringify(path) : path,
		})

		webApiService.send(sendRequest);
	}

	async IsImageExtension(ext: string) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'IsImageExtension',
			Value: typeof(ext) === 'object' ? JSON.stringify(ext) : ext,
		})

		webApiService.send(sendRequest);
	}

	async GetPath(request: string) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'FileS3Service',
			Method: 'GetPath',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Вставка файла
	 */
	async attachFileAsync(request: AttachFileBaseRequest): Promise<AttachFileResponse> {
		return new Promise<AttachFileResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'AttachFile',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<AttachFileResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as AttachFileResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Отправить фото
	 */
	async attachFotoAsync(request: AttachFotoRequest): Promise<AttachFotoResponse> {
		return new Promise<AttachFotoResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'AttachFoto',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<AttachFotoResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as AttachFotoResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Вставка без папки
	 */
	async attachFotoNotFolderAsync(request: FotoRequest): Promise<String> {
		return new Promise<String>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'AttachFotoNotFolder',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<String>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as String)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async removeFotoNotFolderAsync(UrlFoto: string): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'RemoveFotoNotFolder',
				Value: typeof(UrlFoto) === 'object' ? JSON.stringify(UrlFoto) : UrlFoto,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Вставка без обрезки
	 */
	async attachFotoNoCorpAsync(request: AttachFotoRequest): Promise<AttachFotoResponse> {
		return new Promise<AttachFotoResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'AttachFotoNoCorp',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<AttachFotoResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as AttachFotoResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить информацыю о содержимом папки
	 */
	async folderInfoAsync(request: GetInfoRequest): Promise<FilePageResponse> {
		return new Promise<FilePageResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'FolderInfo',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<FilePageResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as FilePageResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Создание папки
	 */
	async createFolderAsync(model: CreateFolderRequest): Promise<String> {
		return new Promise<String>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'CreateFolder',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<String>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as String)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение прав доступа
	 */
	async getAccessPermissionAsync(model: FolderPermissionRequest): Promise<Array<AccessPermissionResponse>> {
		return new Promise<Array<AccessPermissionResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'GetAccessPermission',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<Array<AccessPermissionResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<AccessPermissionResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Проверка доступа
	 */
	async isAccessPermissionAsync(model: AccessPermissionRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'IsAccessPermission',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async moveFileAsync(model: MoveFilesRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'MoveFile',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async moveFolderAsync(model: MoveFolderRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'MoveFolder',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление файла
	 */
	async removeFileAsync(model: RemoveFileRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'RemoveFile',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удаление папки
	 */
	async removeFolderAsync(model: RemoveFolderRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'RemoveFolder',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Установка прав
	 */
	async setAccessPermissionAsync(model: AccessPermissionRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'SetAccessPermission',
				Value: typeof(model) === 'object' ? JSON.stringify(model) : model,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async combinePathFolderAsync(request: CombinePathFolderRequest): Promise<String> {
		return new Promise<String>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'CombinePathFolder',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<String>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as String)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async detectCopyFilesAsync(path: string): Promise<String> {
		return new Promise<String>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'DetectCopyFiles',
				Value: typeof(path) === 'object' ? JSON.stringify(path) : path,
				Callback: (response: WsResponseModelT<String>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as String)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async isImageExtensionAsync(ext: string): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'IsImageExtension',
				Value: typeof(ext) === 'object' ? JSON.stringify(ext) : ext,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async getPathAsync(request: string): Promise<String> {
		return new Promise<String>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'FileS3Service',
				Method: 'GetPath',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<String>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as String)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}